<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="等级名称" prop="levelName">
            <el-input v-model="form.levelName" placeholder="请输入等级名称" />
          </el-form-item>
          <el-form-item label="经验值要求" prop="empiricalValue">
            <el-input v-model="form.empiricalValue" placeholder="请输入经验值要求" />
          </el-form-item>
          <el-form-item label="绑定等级权益" prop="bindRaiId">
            <el-select v-model="form.bindRaiId" style="width: 100%;" placeholder="请选择绑定等级权益">
              <el-option v-for="(item,index) in allLevelEquity" :key="index" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        levelName: '', // 等级名称
        empiricalValue: '', // 经验值要求
        bindRaiId: '' // 绑定等级权益
      },
      rules: {
        levelName: [
          { required: true, message: '请输入等级名称', trigger: 'blur' }
        ],
        empiricalValue: [
          { required: true, message: '请输入经验值要求', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (/^(?:[1-9]\d*)$/.test(value) === true || Number(value) === 0) {
              callback()
            } else {
              callback(new Error('请输入正整数'))
            }
          },
          trigger: 'blur'
          }
        ],
        bindRaiId: [
          { required: true, message: '请绑定权益', trigger: 'blur' }
        ],
      },
      allLevelEquity: []
    }
  },
  mounted() {
    this.getLevelEquity()
  },
  methods: {
    getLevelEquity() {
      this.$store.dispatch('form/handle', {
        url: '/business/userLevel/bindRaiList',
        method: 'get',
        callback: (resp) => {
          this.allLevelEquity = resp
        }
      })
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      // 表单校验通过
      if (ruleFormBool) {
        this.$store.dispatch('form/handle', {
          url: '/business/userLevel/add',
          data: this.form,
          method: 'get',
          callback: resp => {
            this.$router.go(-1)
          }
        })
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/equityManagement/addUserLevel.vue